import _ from 'underscore'
import axios from 'axios'
import appRouter from '@/router'
import dateUtils from '@/utils/dateUtils'
import { SERVICE_URL } from "../../_commons"

const namespaced = true;

const state = {
  plateNumber: '',
  registrationType: {},
  vinNumberLastSix: '',
  isVehicleOwnerConsented: false,

  isButton: undefined,
  registrationExpiration: '',
  stickerExpiration: '',
  statusDescription: '',
  statusActions: [],

  allRegistrationTypes: [],
};

const mutations = {
  setState(state, data) {
    state[data.property] = data.value; 
  }
};

const actions = {
  /**
   * Looks up registration status based on user inputs.
   * @param state
   * @param commit
   * @param rootState
   * @returns {Promise<void>}
   */
  async getVehicleRegistrationStatus({ state, commit, rootState }) {
    const endpoint = `${SERVICE_URL}registration/status`;

    const params = {
      plateNumber: state.plateNumber,
      registrationTypeCode: state.registrationType.code,
      vinNumberLastSix: state.vinNumberLastSix,
      isVehicleOwnerConsented: state.isVehicleOwnerConsented,
    };

    axios.get(endpoint, { params } )
      .then(result => {
        commit('setState', { property: 'isButton', value: result.data.isTypeButton });
        commit('setState', { property: 'registrationExpiration', value: result.data.registrationExpirationDate });
        commit('setState', { property: 'stickerExpiration', value: result.data.stickerExpirationDate });
        commit('setState', { property: 'statusDescription', value: result.data.registrationStatusDescription });
        commit('setState', { property: 'statusActions', value: result.data.registrationStatusActionCollection });

        // move on to status screen IFF it's a 200
        if (result.status === rootState.STATUSES.SUCCESS) {
          appRouter.push({ name: 'VehicleStatus' });
        }
      })
      .catch(error => {
        console.error(error);
      });
  },

  /**
   * Gets full list of registration types for UI drop down.
   * @returns {({code: string, description: string}|...)[]}
   */
  getTypeList({ commit }) {
    const endpoint = `${SERVICE_URL}lookup/registrationtypes`

    axios.get(endpoint)
      .then(response => {
        commit('setState', { property: 'allRegistrationTypes', value: response.data });
      })
      .catch(error => {
        console.error(error);
      })
  },

  /**
   * Sets vehicle property values based on user inputs. Optionally invoke the lookup call.
   * @param context
   * @param data
   * @returns {Promise<void>}
   */
  async setVehicleData(context, data) {
    const { runLookup, ...props } = data;
    // save module properties
    _.mapObject(props, (val, key) => {
      context.commit('setState', { property: key, value: val });
    });

    // do lookup?
    if (runLookup) {
      await context.dispatch('getVehicleRegistrationStatus');
    }
  },
};

const getters = {
  lookupInfo: state => ({
    allRegistrationTypes: state.allRegistrationTypes,
  }),
  statusInfo: state => ({
    plateNumber: state.plateNumber,
    registrationType: state.registrationType,
    vinNumberLastSix: state.vinNumberLastSix,

    isButton: state.isButton,
    registrationExpiration: dateUtils.formatMonthDayYear(state.registrationExpiration),
    stickerExpiration: dateUtils.formatMonthDayYear(state.stickerExpiration),
    statusDescription: state.statusDescription,
    statusActions: state.statusActions,
  }),
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
}
